import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card } from './ui/card';

export const InsuredList = ({ insured, onChange }) => {
  const handleAddInsured = () => {
    onChange([...insured, { name: '', dob: '', relationship: '' }]);
  };

  const handleRemoveInsured = (index) => {
    const newInsured = insured.filter((_, i) => i !== index);
    onChange(newInsured);
  };

  const handleChange = (index, field, value) => {
    const newInsured = [...insured];
    newInsured[index] = { ...newInsured[index], [field]: value };
    onChange(newInsured);
  };

  return (
    <div className="space-y-4">
      {insured.map((person, index) => (
        <Card key={index} className="bg-slate-50 border border-[#e0e0e0] rounded-[10px] p-4">
          <div className="flex items-start justify-between mb-3">
            <h4 className="text-sm font-semibold text-slate-700">
              Asegurado Adicional #{index + 1}
            </h4>
            <Button
              data-testid={`remove-insured-${index}`}
              type="button"
              onClick={() => handleRemoveInsured(index)}
              variant="ghost"
              size="sm"
              className="text-red-600 hover:bg-red-50 -mt-2 -mr-2"
            >
              <Trash2 size={16} />
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Nombre Completo*
              </Label>
              <Input
                data-testid={`additional-insured-name-${index}`}
                value={person.name}
                onChange={(e) => handleChange(index, 'name', e.target.value)}
                required
                className="mt-1"
              />
            </div>
            <div>
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Fecha de Nacimiento*
              </Label>
              <Input
                data-testid={`additional-insured-dob-${index}`}
                type="date"
                value={person.dob}
                onChange={(e) => handleChange(index, 'dob', e.target.value)}
                required
                className="mt-1"
              />
            </div>
            <div>
              <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Relación
              </Label>
              <Input
                data-testid={`additional-insured-relationship-${index}`}
                value={person.relationship || ''}
                onChange={(e) => handleChange(index, 'relationship', e.target.value)}
                placeholder="Ej: Hijo, Cónyuge, Padre"
                className="mt-1"
              />
            </div>
          </div>
        </Card>
      ))}

      <Button
        data-testid="add-insured-button"
        type="button"
        onClick={handleAddInsured}
        variant="outline"
        className="w-full border-[#2537b0] text-[#2537b0] hover:bg-blue-50"
      >
        <Plus size={20} className="mr-2" />
        Agregar Asegurado Adicional
      </Button>
    </div>
  );
};
